import ReactTagManager from 'react-gtm-module';

import { TagManager } from 'app/analytics/TagManager';

/**
 * @param cuid Идентификатор пользователя
 * @param dop_info Канал продаж
 */
interface IEventAttribute {
    cuid?: string;
    dop_info?: string;
}

/**
 * Позволяет инициализировать работу аналитики {@link initialize}.
 *
 * Позволяет сформировать событие аналитики в соответсвии с заданным паттерном:
 *    '(префикс)_(основа события аналитики)_(дополнительный параметр 1)_(дополнительный параметр 2)'
 * Пример:
 *    'acquiring_menu_terminal_tid1_unp123'
 *
 * И отправлять сформированное событие {@link sendEvent} в Google Tag Manager.
 */
class GoogleTagManager implements TagManager<string> {
    constructor(eventPrefix: string) {
        this.EVENT_PREFIX = eventPrefix;
    }

    /**
     * Префикс проставляемый перед каждым отправляемым событием. Является названием проекта.
     */
    private readonly EVENT_PREFIX: string;

    /**
     * Символ разделяющий параметры в отправляемом событии.
     */
    private SEPARATOR = '_';

    /**
     * Требуется инициализировать работу аналитики перед отправкой событий.
     *
     * Инициализация происходит перед встраиванием React-приложения в DOM.
     *
     * @param gtmId - Google Tag Manager ID.
     */
    initialize(gtmId: string) {
        ReactTagManager.initialize({ gtmId });
    }

    /**
     * Отправляет сформированное событие в GoogleTagManager.
     *
     * @param eventParts - динамические суффиксы события разделяются между собой {@link this.SEPARATOR}.
     * @param attributes - дополнительные атрибуты
     */
    sendEvent(eventParts: Array<string>, attributes: IEventAttribute = {}) {
        const fullEventName = [this.EVENT_PREFIX, ...eventParts].join(
            this.SEPARATOR,
        );
        const eventObject = { event: fullEventName };

        const dataLayer = { ...eventObject, ...attributes };

        ReactTagManager.dataLayer({ dataLayer });
    }
}

const googleTagManager = new GoogleTagManager('getcard');

export default googleTagManager;
